import React from "react";
import { Helmet } from "react-helmet";
import programming from "../assets/programming.jpg";
import Contactfooter from "./contactfooter";
import ContactComponent from "./ContactComponent";
import image1 from "../assets/carousel/image1.webp";
import image2 from "../assets/carousel/image2.webp";
import image3 from "../assets/carousel/image3.webp";
import image4 from "../assets/carousel/image4.webp";
import html from "../assets/services/html.webp";
import css from "../assets/services/css1.jpg";
import js from "../assets/services/js.png";
import react from "../assets/services/react.png";
import angular from "../assets/services/Angular_full_color_logo.webp";
import laravel from "../assets/services/Laravel-Logo.wine.webp";
import vue from "../assets/services/vue.png";
import node from "../assets/services/nodejs.png";
import mongo from "../assets/services/mongo.png";
import mysql from "../assets/services/mysql.png";
import python from "../assets/services/Python.png";
import php from "../assets/services/php.png";
import amazon from "../assets/amazon-web-service.png";
import azure from "../assets/azure.png";
import google from "../assets/google-cloud.png";

const imageData = [
  {
    src: image1,
    text: "We provide top-notch web development services tailored to your business needs.",
  },
  {
    src: image2,
    text: "Our e-commerce solutions help businesses establish a strong online presence.",
  },
  {
    src: image3,
    text: "Experience stunning web designs that enhance user engagement and experience.",
  },
  {
    src: image4,
    text: "Responsive and mobile-friendly designs to ensure accessibility on all devices.",
  },
];

const WebDevelopment = () => {
  return (
    <>
      <Helmet>
        <title>Website Development | theKrisoft</title>
        <meta
          name="description"
          content="theKrisoft offers high-quality web development services, helping businesses create scalable and user-centric digital solutions."
        />
        <meta
          name="keywords"
          content="web development, website design, digital solutions, The Krisoft, responsive web design, user experience, business growth"
        />
        <meta name="author" content="The Krisoft" />
      </Helmet>

      <div
        className=" bg-cover bg-center relative flex items-center justify-center md:justify-end"
        style={{ backgroundImage: `url(${programming})`, height: "80vh" }}
      >
        <div className="w-full max-w-xs bg-[rgba(255,255,255,0.8)] p-4 rounded-lg shadow-lg mx-auto md:mx-0 md:mr-16 md:max-w-sm">
          <ContactComponent />
        </div>
      </div>
      {/* information content */}
      {/* first content */}
      <div className=" mx-auto">
        {/* Section 1: Modern Web Solutions */}
        <div className="bg-gray-200 p-5">
          <p className="text-4xl text-center">Website Development</p>
          <hr className="bg-orange-700 h-1 w-40 mx-auto my-2" />
          <div className="container p-6 flex flex-col lg:flex-row items-center gap-6">
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src="https://img.freepik.com/free-vector/programming-concept-illustration_114360-1351.jpg"
                alt="Programming Illustration"
                className="w-full max-w-md h-80 animate-moveUpDown"
              />
            </div>
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <h4 className="text-orange-700 text-3xl lg:text-5xl">
                Modern Web Solutions
              </h4>
              <ul className="mt-5 list-disc list-inside text-sm md:text-base">
                <li>
                  We develop websites using HTML, CSS, JavaScript, React.js,
                  Angular, and Vue.js.
                </li>
                <li>
                  Our websites are fully responsive and adapt seamlessly to all
                  screen sizes.
                </li>
                <li>
                  Expertise in both frontend and backend development for dynamic
                  applications.
                </li>
                <li>
                  SEO-optimized development ensures better search rankings.
                </li>
                <li>
                  Scalable and high-performance solutions for long-term growth.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Section 2: Interactive & Animated Web Experiences */}
        <div className="bg-gray-300 p-5">
          <div className="container p-6 flex flex-col lg:flex-row items-center gap-6">
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <h4 className="text-orange-700 text-3xl lg:text-5xl">
                Interactive & Animated Web Experiences
              </h4>
              <ul className="mt-5 list-disc list-inside text-sm md:text-base">
                <li>
                  We create smooth and engaging animations using AOS, GSAP, and
                  CSS effects.
                </li>
                <li>
                  Custom web applications with sleek transitions and interactive
                  UI elements.
                </li>
                <li>
                  Fully optimized for mobile, tablet, and desktop devices.
                </li>
                <li>
                  Secure authentication and API integrations for enhanced
                  functionality.
                </li>
                <li>
                  Performance-optimized for fast loading speeds and a seamless
                  experience.
                </li>
              </ul>
            </div>
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src="https://img.freepik.com/free-vector/pair-programming-concept-illustration_114360-1812.jpg"
                alt="Programming Illustration"
                className="w-full max-w-md h-80 animate-moveUpDown"
              />
            </div>
          </div>
        </div>

        {/* Section 3: Backend & API Development */}
        <div className="bg-gray-200 p-5">
          <div className="container p-6 flex flex-col lg:flex-row items-center gap-6">
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src="https://img.freepik.com/free-vector/coding-workshop-concept-illustration_114360-8192.jpg"
                alt="Programming Illustration"
                className="w-full max-w-md h-80 animate-moveUpDown"
              />
            </div>
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <h4 className="text-orange-700 text-3xl lg:text-5xl">
                Backend & API Development
              </h4>
              <ul className="mt-5 list-disc list-inside text-sm md:text-base">
                <li>
                  We build dynamic applications using Node.js, Express.js, PHP,
                  and MongoDB.
                </li>
                <li>Secure database management with MySQL and MongoDB.</li>
                <li>
                  Custom API development for third-party integrations and
                  automation.
                </li>
                <li>Cloud-based deployment for scalability and performance.</li>
                <li>
                  Strong security measures to protect against cyber threats.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* what we used  */}
      <div className=" bg-[#FAEBCC] p-4">
        <div className="mt-9 mb-11 md:mt-16">
          <h3 className="text-center text-3xl text-red-800 font-bold mb-6">
            <span className="font-dancing pr-4 text-4xl ">Technologies</span>
            Web Developement
          </h3>
          <hr className="bg-red-800 mt-6 h-1 w-36 mx-auto mb-14" />
          <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 px-10 mt-6 items-center justify-center">
            {[
              { src: html, name: "HTML" },
              { src: css, name: "CSS" },
              { src: js, name: "JavaScript" },
              { src: react, name: "React" },
              { src: angular, name: "Angular" },
              { src: laravel, name: "Laravel" },
              { src: vue, name: "Vue.js" },
              { src: node, name: "Node.js" },
              { src: python, name: "Python" },
              { src: mongo, name: "MongoDB" },
              { src: php, name: "PHP" },
              { src: mysql, name: "MySQL" },
            ].map((tech, index) => (
              <div key={index} className="flex flex-col items-center">
                <img
                  src={tech.src}
                  alt={tech.name}
                  className="shadow-md w-24 h-24 hover:shadow-xl transition duration-300 rounded-lg bg-transparent"
                />
                <p className="mt-2 text-sm font-medium text-gray-700">
                  {tech.name}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-9 mb-11 md:mt-16">
          <h1 className="text-center text-4xl text-red-800 font-bold">
            <span className="font-dancing pr-4">Cloud</span>Technologies
          </h1>
          <hr className="bg-red-800 mt-6 h-1 w-36 mx-auto" />
          <div className="flex flex-wrap gap-4 mt-10 justify-center">
            <img src={google} alt="google" className="sm:w-32 md:w-48" />
            <img src={azure} alt="Azure" className="sm:w-32 md:w-48" />
            <img src={amazon} alt="amazon" className="sm:w-24 md:w-48" />
          </div>
        </div>
      </div>

      <div className="text-center px-6 py-10">
        <h1 className="text-4xl font-bold">
          Benefits of Website Development with The Krisoft
        </h1>
        <p className="mt-6 text-lg">
          We offer comprehensive web design services in Mumbai and beyond,
          working closely with clients to ensure their website aligns with
          business goals.
        </p>
      </div>

      <div className="w-4/5 mx-auto py-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {imageData.map((item, index) => (
          <div key={index} className="flex flex-col items-center text-center">
            <img
              src={item.src}
              alt="Web Development Service"
              className="w-40 h-auto rounded-lg mb-4 shadow-md"
            />
            <p className="text-sm text-gray-600">{item.text}</p>
          </div>
        ))}
      </div>
      <Contactfooter />
      <style>
        {`
          @keyframes moveUpDown {
            0% { transform: translateY(0); }
            50% { transform: translateY(-20px); }
            100% { transform: translateY(0); }
          }
           h-80.animate-moveUpDown {
            animation: moveUpDown 2s ease-in-out infinite;
          }
        `}
      </style>
    </>
  );
};

export default WebDevelopment;
